// extracted by mini-css-extract-plugin
export default {"container":"Kca-z","oos":"Lca-z","oosUx":"Mca-z","selected":"Nca-z","labelOos":"Oca-z"};